module.exports = __webpack_public_path__ + "static/img/img_3_xuzhangsheng.94587a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_3_xuzhangsheng.png
// module id = GnUN
// module chunks = 0